<template>
  <dara-item-table-layout v-if="columns">
    <template #name>
      <dara-p class="gray-text">
        {{ $t(columns[0]) }}
      </dara-p>
    </template>
    <template #firstColumn>
      <div @click="orderBy(columns[1])">
        <dara-p class="header cursor--pointer" :class="selected === columns[1] ? 'selected' : ''">
          {{ $t(columns[1]) }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #secondColumn>
      <div @click="orderBy(columns[2])">
        <dara-p class="header cursor--pointer" :class="selected === columns[2] ? 'selected' : ''">
          {{ $t(columns[2]) }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #thirdColumn>
      <div @click="orderBy(columns[3])">
        <dara-p class="header cursor--pointer" :class="selected === columns[3] ? 'selected' : ''">
          {{ $t(columns[3]) }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #fourthColumn>
      <div @click="orderBy(columns[4])">
        <dara-p class="header cursor--pointer" :class="selected === columns[4] ? 'selected' : ''">
          {{ $t(columns[4]) }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
  </dara-item-table-layout>
</template>

<script>
import DaraItemTableLayout from '@/layouts/ItemTableLayout.vue';

export default {
  name: 'DaraTableHeader',
  components: {
    DaraItemTableLayout,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: this.columns[1],
      order: 'DESC',
    };
  },
  methods: {
    invertOrder(order) {
      return order === 'ASC' ? 'DESC' : 'ASC';
    },
    orderBy(column) {
      if (this.selected === column) {
        this.order = this.invertOrder(this.order);
        this.$emit('orderBy', { by: column, order: this.order });
      } else {
        this.selected = column;
        this.$emit('orderBy', { by: column, order: this.order });
      }
    },
  },
};
</script>

<style scoped>

  .gray-text {
    color: #868E96 !important;
    font-size: 14px !important;
  }
  .header {
    color: #868E96 !important;
    font-size: 14px !important;
  }
  .header:hover {
    color: #409eff !important;
  }
  .selected {
    color: #409eff !important;
    filter: grayscale(0%) !important;
    opacity: 1 !important;
  }

</style>
